import React, { ErrorInfo } from 'react';
import Container from '../../../grid/container';
import ErrorCallout from '../../organisms/callout/error-callout';
import Card, { CardBlock } from '../../organisms/card';
import Collapse from '../../organisms/collapse';

/**
 * Error Boundaries cannot be functional components yet
 * getDerivedStateFromError(error) does not have a functional
 * component equivalent yet
 *
 * References:
 * https://btholt.github.io/complete-intro-to-react-v5/typescript
 * https://github.com/bvaughn/react-error-boundary/blob/master/src/index.js
 * https://codepen.io/gaearon/pen/wqvxGa?editors=0010
 * https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
 */
interface ErrorBoundaryType {
  error: Error;
  info: ErrorInfo;
}
class ErrorBoundary extends React.Component<unknown, ErrorBoundaryType> {
  constructor(props: unknown) {
    super(props);
    this.state = {
      error: null,
      info: null
    };
  }
  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Log error to Elastic search or Matomo?
    this.setState({ error, info });
  }
  render(): React.ReactNode {
    if (this.state.error) {
      return (
        // TODO: Make errors easy for users to submit (e.g. copy error into new support message on click)
        <Container>
          <ErrorCallout className="mt-8">
            <p>Error: {this.state.error.message}</p>
            <pre>{this.state.error.stack}</pre>
          </ErrorCallout>
          <Card className="my-4">
            <CardBlock>
              <Collapse header={<div>View Component Stack</div>}>
                <pre>
                  Component stack:
                  {this.state.info?.componentStack}
                </pre>
              </Collapse>
            </CardBlock>
          </Card>
        </Container>
      );
    }
    // If no error, render children
    return this.props.children;
  }
}

export default ErrorBoundary;
